//common permissions
export const GROUP_MESSAGING = 'group_messaging';
export const BROADCAST_MESSAGING = 'broadcast_messaging';
export const RESIDENT_CALENDAR = 'resident_calendar';
export const PATIENT_INFO = 'patient_info';
export const INVITATIONS = 'invitations';
export const JUST_DO_IT = 'just_do_it';
export const NOTIFICATIONS = 'notifications';
export const RESIDENT_ADMINISTRATION = 'resident_administration';
export const BASE_SETUP_STAFF_PERMISSIONS = 'base_setup_staff_permissions';

//VA
export const STAFF_SCHEDULING = 'staff_scheduling';

/**
 * Applies to both Immunization and Readiness calendar events
 */
export const IMMUNIZATION_SCHEDULER = 'immunization_scheduler';
export const READINESS_CALENDAR = 'readiness_calendar';
export const IMMUNIZATION_CHECKLIST = 'immunizations';
export const READINESS_CLEARANCE = 'readiness_clearance';
export const DRHA = 'drha';
export const LABS = 'labs';
export const AUDIOGRAM = 'audiogram';
export const PHA = 'pha';
export const OHE = 'ohe_scheduler';
export const SHPE_SCHEDULER = 'shpe_scheduler';
export const SERE_ECAC_SCHEDULER = 'sere_ecac_scheduler';
export const SPIROMETRY_SCHEDULER = 'spirometry_scheduler';
export const AUDIOGRAM_SPIROMETRY_SCHEDULER = 'audiogram_spirometry_scheduler';
export const SECURITY_FORCES_PCM_SCHEDULER = 'security_forces_pcm_scheduler';
export const DENTAL_SCHEDULER = 'dental_scheduler';
export const CMR_SCHEDULER = 'cmr_scheduler';
export const FLY_CMR_SCHEDULER = 'fly_cmr_scheduler';
export const IMAGING_IMPORT_PICKUP_SCHEDULER = 'imaging_import_pickup_scheduler';
export const COMMUNITY_HEALTH_INTERVIEW_SCHEDULER = 'community_health_interview_scheduler';
export const TRAVEL_MEDICINE_SCHEDULER = 'travel_medicine_scheduler';
export const SPECIALTY_HEARING_SCHEDULER = 'specialty_hearing_scheduler';
export const ANAM_TEST_SCHEDULER = 'anam_test_scheduler';
export const CONSULTS_ADMINISTRATION = 'consults_administration';
export const BASE_REPORTS = 'base_reports';
export const ON_CALL_SCHEDULING = 'on_call_scheduling';
export const BASE_SETUP_SCHEDULE_HOURS_LABS = 'base_setup_schedule_hours_labs';
export const BASE_SETUP_SCHEDULE_HOURS_IMM = 'base_setup_schedule_hours_imm';
export const BASE_SETUP_SCHEDULE_HOURS_AUDIO = 'base_setup_schedule_hours_audio';
export const BASE_SETUP_SCHEDULE_HOURS_PHA = 'base_setup_schedule_hours_pha';
export const BASE_SETUP_SCHEDULE_HOURS_DRHA = 'base_setup_schedule_hours_drha';
export const BASE_SETUP_SCHEDULE_HOURS_OHE = 'base_setup_schedule_hours_ohe';
export const BASE_SETUP_SCHEDULE_HOURS_SHPE = 'base_setup_schedule_hours_shpe';
export const BASE_SETUP_SCHEDULE_HOURS_SERE_ECAC = 'base_setup_schedule_hours_sere_ecac';
export const BASE_SETUP_SCHEDULE_HOURS_SPIROMETRY = 'base_setup_schedule_hours_spirometry';
export const BASE_SETUP_SCHEDULE_HOURS_AUDIOGRAM_SPIROMETRY =
  'base_setup_schedule_hours_audiogram_spirometry';
export const BASE_SETUP_SCHEDULE_HOURS_SECURITY_FORCES_PCM =
  'base_setup_schedule_hours_security_forces_pcm';
export const BASE_SETUP_SCHEDULE_HOURS_DENTAL = 'base_setup_schedule_hours_dental';
export const BASE_SETUP_SCHEDULE_HOURS_IMAGING_IMPORT_PICKUP =
  'base_setup_schedule_hours_imaging_import_pickup';
export const BASE_SETUP_SCHEDULE_HOURS_ANAM_TEST = 'base_setup_schedule_hours_anam_test';
export const BASE_SETUP_SCHEDULE_HOURS_COMMUNITY_HEALTH_INTERVIEW =
  'base_setup_schedule_hours_community_health_interview';
export const BASE_SETUP_SCHEDULE_HOURS_TRAVEL_MEDICINE =
  'base_setup_schedule_hours_travel_medicine';
export const BASE_SETUP_SCHEDULE_HOURS_SPECIALTY_HEARING =
  'base_setup_schedule_hours_specialty_hearing';
export const BASE_SETUP_SCHEDULE_HOURS_CMR = 'base_setup_schedule_hours_cmr';
export const BASE_SETUP_SCHEDULE_HOURS_FLY_CMR = 'base_setup_schedule_hours_fly_cmr';
export const BASE_SETUP_SQ_MED_SVC_CLINICAL_LOC = 'base_setup_sq_med_svc_clinical_loc';
export const BASE_SETUP_OCC_HEALTH = 'base_setup_occ_health';
export const OCC_HEALTH_CLEARANCE = 'occ_health_clearance';
export const BASE_SETUP_NOTIFICATIONS = 'base_setup_notifications';

export const PERMISSION_VAL_NO_ACCESS = null;
export const PERMISSION_VAL_VIEW_ONLY = false;
export const PERMISSION_VAL_CAN_EDIT = true;

export const PERSONAL_CASE_PERMISSIONS = {
  [GROUP_MESSAGING]: PERMISSION_VAL_CAN_EDIT,
  [RESIDENT_CALENDAR]: PERMISSION_VAL_CAN_EDIT,
  [PATIENT_INFO]: PERMISSION_VAL_CAN_EDIT,
  [INVITATIONS]: PERMISSION_VAL_CAN_EDIT,
  [JUST_DO_IT]: PERMISSION_VAL_CAN_EDIT,
  [NOTIFICATIONS]: PERMISSION_VAL_CAN_EDIT,

  [RESIDENT_ADMINISTRATION]: PERMISSION_VAL_CAN_EDIT,

  [IMMUNIZATION_SCHEDULER]: PERMISSION_VAL_NO_ACCESS,
  [READINESS_CALENDAR]: PERMISSION_VAL_NO_ACCESS,
  [IMMUNIZATION_CHECKLIST]: PERMISSION_VAL_VIEW_ONLY,
  [BROADCAST_MESSAGING]: PERMISSION_VAL_NO_ACCESS,
  [READINESS_CLEARANCE]: PERMISSION_VAL_NO_ACCESS,
  [DRHA]: PERMISSION_VAL_NO_ACCESS,
  [LABS]: PERMISSION_VAL_NO_ACCESS,
  [AUDIOGRAM]: PERMISSION_VAL_NO_ACCESS,
  [PHA]: PERMISSION_VAL_NO_ACCESS,
  [OHE]: PERMISSION_VAL_NO_ACCESS,
  [SHPE_SCHEDULER]: PERMISSION_VAL_NO_ACCESS,
  [SERE_ECAC_SCHEDULER]: PERMISSION_VAL_NO_ACCESS,
  [SPIROMETRY_SCHEDULER]: PERMISSION_VAL_NO_ACCESS,
  [AUDIOGRAM_SPIROMETRY_SCHEDULER]: PERMISSION_VAL_NO_ACCESS,
  [SECURITY_FORCES_PCM_SCHEDULER]: PERMISSION_VAL_NO_ACCESS,
  [DENTAL_SCHEDULER]: PERMISSION_VAL_NO_ACCESS,
  [CMR_SCHEDULER]: PERMISSION_VAL_NO_ACCESS,
  [FLY_CMR_SCHEDULER]: PERMISSION_VAL_NO_ACCESS,
  [IMAGING_IMPORT_PICKUP_SCHEDULER]: PERMISSION_VAL_NO_ACCESS,
  [COMMUNITY_HEALTH_INTERVIEW_SCHEDULER]: PERMISSION_VAL_NO_ACCESS,
  [TRAVEL_MEDICINE_SCHEDULER]: PERMISSION_VAL_NO_ACCESS,
  [SPECIALTY_HEARING_SCHEDULER]: PERMISSION_VAL_NO_ACCESS,
  [ANAM_TEST_SCHEDULER]: PERMISSION_VAL_NO_ACCESS,
  [CONSULTS_ADMINISTRATION]: PERMISSION_VAL_NO_ACCESS,
  [BASE_REPORTS]: PERMISSION_VAL_NO_ACCESS,
  [ON_CALL_SCHEDULING]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_LABS]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_IMM]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_AUDIO]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_PHA]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_DRHA]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_OHE]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_SHPE]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_SERE_ECAC]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_SPIROMETRY]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_AUDIOGRAM_SPIROMETRY]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_SECURITY_FORCES_PCM]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_DENTAL]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_IMAGING_IMPORT_PICKUP]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_COMMUNITY_HEALTH_INTERVIEW]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_TRAVEL_MEDICINE]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_SPECIALTY_HEARING]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_ANAM_TEST]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_CMR]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_FLY_CMR]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SQ_MED_SVC_CLINICAL_LOC]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_STAFF_PERMISSIONS]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_OCC_HEALTH]: PERMISSION_VAL_NO_ACCESS,
  [OCC_HEALTH_CLEARANCE]: PERMISSION_VAL_NO_ACCESS,
};

// patient perms
export const FAMILY_MEMBER_PERMISSIONS = {
  [GROUP_MESSAGING]: PERMISSION_VAL_CAN_EDIT,
  [RESIDENT_CALENDAR]: PERMISSION_VAL_CAN_EDIT,
  [PATIENT_INFO]: PERMISSION_VAL_CAN_EDIT,
  [INVITATIONS]: PERMISSION_VAL_NO_ACCESS,
  [JUST_DO_IT]: PERMISSION_VAL_VIEW_ONLY,
  [NOTIFICATIONS]: PERMISSION_VAL_CAN_EDIT,

  [RESIDENT_ADMINISTRATION]: PERMISSION_VAL_CAN_EDIT,

  // Airforce specific
  [IMMUNIZATION_SCHEDULER]: PERMISSION_VAL_NO_ACCESS,
  [READINESS_CALENDAR]: PERMISSION_VAL_NO_ACCESS,
  [IMMUNIZATION_CHECKLIST]: PERMISSION_VAL_NO_ACCESS,
  [BROADCAST_MESSAGING]: PERMISSION_VAL_NO_ACCESS,
  [READINESS_CLEARANCE]: PERMISSION_VAL_NO_ACCESS,
  [DRHA]: PERMISSION_VAL_VIEW_ONLY,
  [LABS]: PERMISSION_VAL_VIEW_ONLY,
  [AUDIOGRAM]: PERMISSION_VAL_VIEW_ONLY,
  [PHA]: PERMISSION_VAL_VIEW_ONLY,
  [OHE]: PERMISSION_VAL_VIEW_ONLY,
  [SHPE_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [SERE_ECAC_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [SPIROMETRY_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [AUDIOGRAM_SPIROMETRY_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [SECURITY_FORCES_PCM_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [DENTAL_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [CMR_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [FLY_CMR_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [IMAGING_IMPORT_PICKUP_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [COMMUNITY_HEALTH_INTERVIEW_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [TRAVEL_MEDICINE_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [SPECIALTY_HEARING_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [ANAM_TEST_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [CONSULTS_ADMINISTRATION]: PERMISSION_VAL_NO_ACCESS,
  [BASE_REPORTS]: PERMISSION_VAL_NO_ACCESS,
  [ON_CALL_SCHEDULING]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_LABS]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_IMM]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_AUDIO]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_PHA]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_DRHA]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_OHE]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_SHPE]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_SERE_ECAC]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_SPIROMETRY]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_AUDIOGRAM_SPIROMETRY]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_SECURITY_FORCES_PCM]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_DENTAL]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_IMAGING_IMPORT_PICKUP]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_COMMUNITY_HEALTH_INTERVIEW]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_TRAVEL_MEDICINE]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_SPECIALTY_HEARING]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_ANAM_TEST]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_CMR]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_FLY_CMR]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SQ_MED_SVC_CLINICAL_LOC]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_STAFF_PERMISSIONS]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_OCC_HEALTH]: PERMISSION_VAL_NO_ACCESS,
  [OCC_HEALTH_CLEARANCE]: PERMISSION_VAL_NO_ACCESS,
};

export const TEST_PERMISSIONS = {
  [GROUP_MESSAGING]: PERMISSION_VAL_NO_ACCESS,
  [RESIDENT_CALENDAR]: PERMISSION_VAL_CAN_EDIT,
  [PATIENT_INFO]: PERMISSION_VAL_CAN_EDIT,
  [INVITATIONS]: PERMISSION_VAL_VIEW_ONLY,
  [JUST_DO_IT]: PERMISSION_VAL_VIEW_ONLY,
  [NOTIFICATIONS]: PERMISSION_VAL_CAN_EDIT,

  [RESIDENT_ADMINISTRATION]: PERMISSION_VAL_CAN_EDIT,

  // Airforce specific
  [IMMUNIZATION_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [READINESS_CALENDAR]: PERMISSION_VAL_VIEW_ONLY,
  [IMMUNIZATION_CHECKLIST]: PERMISSION_VAL_CAN_EDIT,
  [BROADCAST_MESSAGING]: PERMISSION_VAL_NO_ACCESS,
  [READINESS_CLEARANCE]: PERMISSION_VAL_NO_ACCESS,
  [DRHA]: PERMISSION_VAL_VIEW_ONLY,
  [LABS]: PERMISSION_VAL_VIEW_ONLY,
  [AUDIOGRAM]: PERMISSION_VAL_VIEW_ONLY,
  [PHA]: PERMISSION_VAL_VIEW_ONLY,
  [OHE]: PERMISSION_VAL_VIEW_ONLY,
  [SHPE_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [SERE_ECAC_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [SPIROMETRY_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [AUDIOGRAM_SPIROMETRY_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [SECURITY_FORCES_PCM_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [DENTAL_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [CMR_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [FLY_CMR_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [IMAGING_IMPORT_PICKUP_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [COMMUNITY_HEALTH_INTERVIEW_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [TRAVEL_MEDICINE_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [SPECIALTY_HEARING_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [ANAM_TEST_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [CONSULTS_ADMINISTRATION]: PERMISSION_VAL_NO_ACCESS,
  [BASE_REPORTS]: PERMISSION_VAL_NO_ACCESS,
  [ON_CALL_SCHEDULING]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_LABS]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_IMM]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_AUDIO]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_PHA]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_DRHA]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_OHE]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_SHPE]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_SERE_ECAC]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_SPIROMETRY]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_AUDIOGRAM_SPIROMETRY]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_SECURITY_FORCES_PCM]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_DENTAL]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_IMAGING_IMPORT_PICKUP]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_TRAVEL_MEDICINE]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_SPECIALTY_HEARING]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_IMAGING_IMPORT_PICKUP]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_ANAM_TEST]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_CMR]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_FLY_CMR]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SQ_MED_SVC_CLINICAL_LOC]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_STAFF_PERMISSIONS]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_OCC_HEALTH]: PERMISSION_VAL_NO_ACCESS,
  [OCC_HEALTH_CLEARANCE]: PERMISSION_VAL_NO_ACCESS,
};

export const DEFAULT_PERMISSIONS = {
  [GROUP_MESSAGING]: PERMISSION_VAL_VIEW_ONLY,
  [RESIDENT_CALENDAR]: PERMISSION_VAL_VIEW_ONLY,
  [PATIENT_INFO]: PERMISSION_VAL_VIEW_ONLY,
  [INVITATIONS]: PERMISSION_VAL_VIEW_ONLY,
  [JUST_DO_IT]: PERMISSION_VAL_VIEW_ONLY,
  [NOTIFICATIONS]: PERMISSION_VAL_CAN_EDIT,

  [RESIDENT_ADMINISTRATION]: PERMISSION_VAL_VIEW_ONLY,
  [BROADCAST_MESSAGING]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_STAFF_PERMISSIONS]: PERMISSION_VAL_NO_ACCESS,
};

export const DEFAULT_AIRFORCE_PERMISSIONS = {
  [GROUP_MESSAGING]: PERMISSION_VAL_VIEW_ONLY,
  [RESIDENT_CALENDAR]: PERMISSION_VAL_VIEW_ONLY,
  [PATIENT_INFO]: PERMISSION_VAL_VIEW_ONLY,
  [INVITATIONS]: PERMISSION_VAL_VIEW_ONLY,
  [JUST_DO_IT]: PERMISSION_VAL_VIEW_ONLY,
  [NOTIFICATIONS]: PERMISSION_VAL_CAN_EDIT,

  [RESIDENT_ADMINISTRATION]: PERMISSION_VAL_VIEW_ONLY,

  // Airforce specific
  [IMMUNIZATION_SCHEDULER]: PERMISSION_VAL_NO_ACCESS,
  [READINESS_CALENDAR]: PERMISSION_VAL_NO_ACCESS,
  [IMMUNIZATION_CHECKLIST]: PERMISSION_VAL_NO_ACCESS,
  [BROADCAST_MESSAGING]: PERMISSION_VAL_NO_ACCESS,
  [READINESS_CLEARANCE]: PERMISSION_VAL_NO_ACCESS,
  [DRHA]: PERMISSION_VAL_VIEW_ONLY,
  [LABS]: PERMISSION_VAL_VIEW_ONLY,
  [AUDIOGRAM]: PERMISSION_VAL_VIEW_ONLY,
  [PHA]: PERMISSION_VAL_VIEW_ONLY,
  [OHE]: PERMISSION_VAL_VIEW_ONLY,
  [SHPE_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [SERE_ECAC_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [SPIROMETRY_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [AUDIOGRAM_SPIROMETRY_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [SECURITY_FORCES_PCM_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [DENTAL_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [CMR_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [FLY_CMR_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [IMAGING_IMPORT_PICKUP_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [COMMUNITY_HEALTH_INTERVIEW_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [TRAVEL_MEDICINE_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [SPECIALTY_HEARING_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [ANAM_TEST_SCHEDULER]: PERMISSION_VAL_VIEW_ONLY,
  [CONSULTS_ADMINISTRATION]: PERMISSION_VAL_NO_ACCESS,
  [BASE_REPORTS]: PERMISSION_VAL_NO_ACCESS,
  [ON_CALL_SCHEDULING]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_LABS]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_IMM]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_AUDIO]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_PHA]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_DRHA]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_OHE]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_SHPE]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_SERE_ECAC]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_SPIROMETRY]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_AUDIOGRAM_SPIROMETRY]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_SECURITY_FORCES_PCM]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_DENTAL]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_IMAGING_IMPORT_PICKUP]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_COMMUNITY_HEALTH_INTERVIEW]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_TRAVEL_MEDICINE]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_SPECIALTY_HEARING]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_ANAM_TEST]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_CMR]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SCHEDULE_HOURS_FLY_CMR]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_SQ_MED_SVC_CLINICAL_LOC]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_STAFF_PERMISSIONS]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_OCC_HEALTH]: PERMISSION_VAL_NO_ACCESS,
  [OCC_HEALTH_CLEARANCE]: PERMISSION_VAL_NO_ACCESS,
  [BASE_SETUP_NOTIFICATIONS]: PERMISSION_VAL_NO_ACCESS,
};

export const DEFAULT_MED_RECRUITER_PERMISSIONS = {
  [GROUP_MESSAGING]: PERMISSION_VAL_VIEW_ONLY,
  [BROADCAST_MESSAGING]: PERMISSION_VAL_NO_ACCESS,
  [RESIDENT_CALENDAR]: PERMISSION_VAL_VIEW_ONLY,
  [RESIDENT_ADMINISTRATION]: PERMISSION_VAL_VIEW_ONLY,
  [BASE_SETUP_STAFF_PERMISSIONS]: PERMISSION_VAL_NO_ACCESS,
  [STAFF_SCHEDULING]: PERMISSION_VAL_CAN_EDIT,
  [INVITATIONS]: PERMISSION_VAL_CAN_EDIT,
};

export const USERS_CASE_OVERRIDE_PERMISSIONS = {
  [IMMUNIZATION_CHECKLIST]: PERMISSION_VAL_VIEW_ONLY,
  [READINESS_CLEARANCE]: PERMISSION_VAL_VIEW_ONLY,
  [RESIDENT_ADMINISTRATION]: PERMISSION_VAL_CAN_EDIT,
  [PATIENT_INFO]: PERMISSION_VAL_CAN_EDIT,
  [OCC_HEALTH_CLEARANCE]: PERMISSION_VAL_VIEW_ONLY,
};
